import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { fadeIn, fadeInOut } from 'src/app/animations';
@Component({
  selector: 'app-modal-aviso-companheiro',
  templateUrl: './modal-aviso-companheiro.component.html',
  styleUrls: ['./modal-aviso-companheiro.component.css'],
  animations: [fadeIn, fadeInOut]
})
export class ModalAvisoCompanheiroComponent {
  constructor(public activeModal: NgbActiveModal) { }
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  @Input() id: any;
  closeModal() {
    this.passEntry.emit(true);
    this.activeModal.dismiss(null);
  }
}
